import { Injectable, Component } from '@angular/core';
import { Storage } from '@ionic/storage';
import { ToastController, LoadingController } from '@ionic/angular';
import { GuardsCheckStart } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class DeviceService {
    public role: string;
    public me: any = {};
    public accessToken: string;
    public user: any;
    public filters: any = null;
    public cardSelected: any = null;
    public addressSelected: any = null;
    public isLoggedIn;

    constructor(
        public storage: Storage,
        public toastCtrl: ToastController,
        private loadingCtrl: LoadingController) { }

    public setStorage(keyStorage: string, value) {
        // set a key/value
        console.log('se va GuardsCheckStart', keyStorage + ' : ' + JSON.stringify(value));
        this.storage.set(keyStorage, value);
    }

    public removeStorage(keyStorage: string) {
        console.log('se elimino')
        this.storage.remove(keyStorage);
    }

    public setUserRoleStorage(role: string) {
        // set a key/value
        this.storage.set('role', role);
    }

    public removeUserRoleStorage() {
        this.storage.remove('role');
    }


    async getFiltersStorage(key: string): Promise<any> {
        try {
            const result = await this.storage.get(key);
            if (result != null) {
                console.log('storageGET: ' + key + ': ' + JSON.stringify(result));
                this.filters = result;
                return result;
            } else {
                return null;
            }
        } catch (reason) {
            console.log(reason);
            return null;
        }
    }

    // get a key/value object
    public async getObject(key: string): Promise<any> {
        try {
            const result = await this.storage.get(key);
            if (result != null) {
                this.role = result;
                return result;
            }
            return null;
        } catch (reason) {
            console.log(reason);
            return null;
        }
    }

    public async getMe(key: string): Promise<any> {
        try {
            const result = await this.storage.get(key);
            if (result != null) {
                this.me = result;
                console.log('/me como tipo de usuario: ')
                return result;
            }
            return null;
        } catch (reason) {
            console.log(reason);
            return null;
        }
    }

    // get a key/value object
    public async getKeyStorage(key: string): Promise<any> {
        try {
            const result = await this.storage.get(key);
            if (result != null) {
                this.accessToken = result.access_token;
                return result.access_token;
            }
            return null;
        } catch (reason) {
            console.log(reason);
            return null;
        }
    }

    // get a key/value object
    public async getUserStorage(key: string): Promise<any> {
        try {
            const result = await this.storage.get(key);
            if (result != null) {
                this.user = result;
                return result;
            }
            return null;
        } catch (reason) {
            console.log(reason);
            return null;
        }
    }

    // get a key/value object
    public async getCardSelected(key: string): Promise<any> {
        try {
            const result = await this.storage.get(key);
            if (result != null) {
                this.cardSelected = result;
                return result;
            }
            return null;
        } catch (reason) {
            console.log(reason);
            return null;
        }
    }

    // get a key/value object
    public async getAddressSelected(key: string): Promise<any> {
        try {
            const result = await this.storage.get(key);
            if (result != null) {
                this.addressSelected = result;
                return result;
            }
            return null;
        } catch (reason) {
            console.log(reason);
            return null;
        }
    }

    public async showToast(message: string, css: string) {
        const toast = await this.toastCtrl.create({
            message,
            duration: 3000,
            cssClass: css
        });
        toast.present();
    }

    /* Loading */
    async showLoading() {
        const loading = await this.loadingCtrl.create({
            spinner: null,
            // tslint:disable-next-line: max-line-length
            message: '<div class="sk-chase"><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div></div>',
            translucent: false,
            cssClass: 'custom-class',
            duration: 2000,
        });
        return await loading.present();
    }

    /* Loading */
    async showLoadingUntilEnd() {
        const loading = await this.loadingCtrl.create({
            spinner: null,
            // tslint:disable-next-line: max-line-length
            message: '<div class="sk-chase"><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div></div>',
            translucent: false,
            cssClass: 'custom-class',
        });
        return await loading.present();
    }

    async loadingDismiss() {
        return this.loadingCtrl.dismiss();
        console.log('Loading dismissed!');
    }

    public async getFromStorage(key: string): Promise<any> {
        try {
            const result = await this.storage.get(key);

            if (result != null) {
                return result;
            }

            return null;
        } catch (reason) {
            console.log(reason);

            return null;
        }
    }

    public openBrowserExternal(link) {
        window.open(link, '_system', 'location=yes');
    }

}
